var groupsOfLinks = [
  {
    prefix: "/processing",
    links: [
      {
        link: "/shift/create",
        title: "Record Shift",
        rang: "user",
      },
      { link: "/shifts", title: "All Shifts", rang: "user" },
      {
        link: "/repair",
        title: "Repair Log",
        rang: "user",
        sublinks: [
          {
            link: "/create",
            title: "Record Repair",
            rang: "user",
          },
          {
            link: "/show",
            title: "All Repairs",
            rang: "user",
          },
        ],
      },
      {
        link: "/analysis",
        title: "Analysis Log",
        rang: "user",
        sublinks: [
          {
            link: "/create",
            title: "Record Analysis",
            rang: "user",
          },
          {
            link: "/show",
            title: "All Analyses",
            rang: "user",
          },
        ],
      },
    ],
  },
  {
    prefix: "/counteragents",
    links: [
      {
        link: "/create",
        title: "Add Counteragent",
        rang: "user",
      },
      {
        link: "/all",
        title: "All Counteragents",
        rang: "user",
      },
      {
        link: "/employees",
        title: "All Employees",
        rang: "user",
      },
      {
        link: "/suppliers",
        title: "All Suppliers",
        rang: "user",
      },
    ],
  },
  {
    prefix: "/orders",
    links: [
      { link: "/all", title: "All Orders", rang: "user" },
      { link: "/create", title: "Create Order", rang: "user" },
      // {
      //   link: "/return",
      //   title: "Return Goods from Customer",
      //   rang: "user",
      // },
    ],
  },
  {
    prefix: "/counters",
    links: [
      {
        link: "/all",
        title: "All Cashboxes/Accounts",
        rang: "user",
      },

      {
        link: "/payment",
        title: "Payment to Cashbox <-",
        rang: "user",
        sublinks: [
          {
            link: "/counteragent-to-counter",
            title: "Accept Payment from Counteragent",
            rang: "user",
          },
          {
            link: "/to-counter",
            title: "Accept Payment (without Counteragent)",
            rang: "user",
          },
        ],
      },
      {
        link: "/payment",
        title: "Payment from Cashbox ->",
        rang: "user",
        sublinks: [
          {
            link: "/counter-to-counteragent",
            title: "Make Payment to Counteragent",
            rang: "user",
          },
          {
            link: "/from-counter",
            title: "Make Payment (without Counteragent)",
            rang: "user",
          },
        ],
      },
      {
        link: "/counter-to-counter",
        title: "Make Transfer between Cashboxes/Accounts",
        rang: "user",
      },
      {
        link: "/payment/add-on-balance-of-counteragent",
        title: "Credit to Counteragent's Balance",
        rang: "user",
      },
    ],
  },
];

export default groupsOfLinks;
